(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-grid-filters-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bambola-filters')) {
    class BambolaFilters extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.ready = true;
        this.setAttribute('data-bbf-ready', '');
        this.form.addEventListener('input', event => this.onInput(event));
        this.form.addEventListener('change', event => this.onInput(event));
        this.form.addEventListener('submit', event => this.onSubmit(event));
        this.querySelector('[data-bbf-clear]').addEventListener('click', event => {
          event.preventDefault();
          this.peers().forEach(peer => {
            peer.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
            peer.querySelectorAll('[data-bbf-price-min],[data-bbf-price-max]').forEach(input => { input.value = ''; });
            peer.refresh();
          });
        });
        this.refresh();
      }
      peers() {
        return Array.from(document.querySelectorAll('bambola-filters')).filter(peer => peer.dataset.bbfScope === this.dataset.bbfScope && peer.ready);
      }
      onInput(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.matches('[data-bbf-price-slider]')) {
          const max = input.closest('[data-bbf-price]').querySelector('[data-bbf-price-max]');
          max.value = input.value;
          this.syncInput(max);
        } else {
          this.syncInput(input);
        }
        this.peers().forEach(peer => peer.refresh());
      }
      syncInput(input) {
        if (!input.name) return;
        this.peers().forEach(peer => {
          peer.querySelectorAll('input[name]').forEach(other => {
            if (other === input || other.name !== input.name) return;
            if (input.type === 'checkbox') {
              if (other.value === input.value) other.checked = input.checked;
            } else {
              other.value = input.value;
            }
          });
        });
      }
      formatPrice(value, group) {
        try {
          return new Intl.NumberFormat(group.dataset.bbfLocale, {style:'currency', currency:group.dataset.bbfCurrency, maximumFractionDigits:2}).format(value);
        } catch (error) {
          return String(value);
        }
      }
      refresh() {
        const items = [];
        this.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
          items.push({label:input.dataset.bbfLabel, group:input.dataset.bbfGroupLabel, remove:() => {
            input.checked = false;
            this.syncInput(input);
          }});
        });
        this.querySelectorAll('[data-bbf-price]').forEach(group => {
          const min = group.querySelector('[data-bbf-price-min]');
          const max = group.querySelector('[data-bbf-price-max]');
          const slider = group.querySelector('[data-bbf-price-slider]');
          const minValue = min.value === '' ? 0 : Number(min.value);
          const maxValue = max.value === '' ? Number(max.max) : Number(max.value);
          max.setCustomValidity(minValue > maxValue ? this.dataset.bbfPriceError : '');
          slider.value = String(maxValue);
          slider.setAttribute('aria-valuetext', this.formatPrice(maxValue, group));
          if (min.value !== '' || max.value !== '') {
            items.push({label:this.formatPrice(minValue, group)+' – '+this.formatPrice(maxValue, group),group:group.dataset.bbfLabel,remove:() => {
              min.value = '';
              max.value = '';
              this.syncInput(min);
              this.syncInput(max);
            }});
          }
        });
        const chips = this.querySelector('[data-bbf-selected]');
        chips.replaceChildren();
        chips.hidden = !items.length;
        items.forEach(item => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'bbf-active-chip';
          button.setAttribute('aria-label', this.dataset.bbfRemove+': '+item.group+' — '+item.label);
          const label = document.createElement('span');
          label.textContent = item.label;
          const close = document.createElement('span');
          close.textContent = '×';
          close.setAttribute('aria-hidden','true');
          button.append(label,close);
          button.addEventListener('click', () => {
            item.remove();
            this.peers().forEach(peer => peer.refresh());
            const next = this.querySelector('.bbf-active-chip') || this.querySelector('input[type="checkbox"]:not(:disabled)') || this.querySelector('.bbf-submit');
            if (next) next.focus();
          });
          chips.append(button);
        });
        const count = this.querySelector('[data-bbf-count]');
        count.textContent = String(items.length);
        count.hidden = !items.length;
        const secondaryCount = this.querySelectorAll('.bbf-more-filters input[type="checkbox"]:checked').length;
        const secondaryBadge = this.querySelector('[data-bbf-more-count]');
        if (secondaryBadge) {
          secondaryBadge.textContent = String(secondaryCount);
          secondaryBadge.hidden = !secondaryCount;
        }
      }
      onSubmit(event) {
        event.preventDefault();
        this.refresh();
        if (!this.form.reportValidity()) return;
        const url = new URL(this.form.action, window.location.href);
        const params = new URLSearchParams(window.location.search);
        Array.from(params.keys()).forEach(key => {
          if (key.startsWith('filter.') || ['page','section_id','sections'].includes(key)) params.delete(key);
        });
        const data = new FormData(this.form);
        new Set(data.keys()).forEach(key => params.delete(key));
        data.forEach((value,key) => {
          if (typeof value === 'string' && value.trim() !== '') params.append(key,value);
        });
        url.search = params.toString();
        const submit = this.querySelector('.bbf-submit');
        submit.disabled = true;
        submit.setAttribute('aria-busy','true');
        window.location.assign(url.href);
      }
    }
    customElements.define('bambola-filters', BambolaFilters);
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('bambola-filters .bbf-submit').forEach(button => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bambola-mobile-menu')) {
    class BambolaMobileMenu extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          document.addEventListener('drawerOpen.NavDrawer', this.onOpen);
          this.drawer = this.closest('#NavDrawer');
          this.drawer.addEventListener('keydown', this.onTabKey);
          this.bindBamsEvents();
          return;
        }
        this.ready = true;
        this.tabs = Array.from(this.querySelectorAll('[data-bbm-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-bbm-panel]'));
        const tablist = this.querySelector('[data-bbm-tabs]');
        if (tablist) tablist.setAttribute('role', 'tablist');
        this.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.hash.slice(1));
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.selectTab(tab.dataset.bbmTab);
          });
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let index = this.tabs.indexOf(tab);
            if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = this.tabs.length - 1;
            else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.selectTab(this.tabs[index].dataset.bbmTab);
            this.tabs[index].focus();
          });
        });
        this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
        this.selectTab(this.dataset.defaultPanel || 'clothing');
        this.onOpen = () => {
          this.refreshCollections();
          this.refreshBams();
        };
        this.onJoyUpdate = () => this.refreshBams();
        this.joyEvents = ['joy:ready', 'joy:redeemCoupon', 'joy:revokeCoupon'];
        this.drawer = this.closest('#NavDrawer');
        this.onTabKey = event => {
          if (event.key !== 'Tab' || !this.drawer.classList.contains('drawer--is-open')) return;
          const controls = Array.from(this.drawer.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(element => element.tabIndex >= 0 && !element.disabled && element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === this.drawer)) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
        };
        document.addEventListener('drawerOpen.NavDrawer', this.onOpen);
        this.drawer.addEventListener('keydown', this.onTabKey);
        this.bindBamsEvents();
        if (this.closest('#NavDrawer').classList.contains('drawer--is-open')) this.refreshCollections();
      }
      disconnectedCallback() {
        document.removeEventListener('drawerOpen.NavDrawer', this.onOpen);
        this.drawer?.removeEventListener('keydown', this.onTabKey);
        this.joyEvents?.forEach(name => window.removeEventListener(name, this.onJoyUpdate));
        this.bamsRequest = (this.bamsRequest || 0) + 1;
      }
      bindBamsEvents() {
        if (!this.querySelector('[data-bbm-bams]')) return;
        this.joyEvents.forEach(name => window.addEventListener(name, this.onJoyUpdate));
        this.refreshBams();
      }
      async refreshBams() {
        const label = this.querySelector('[data-bbm-bams]');
        if (!label) return;
        const requestId = this.bamsRequest = (this.bamsRequest || 0) + 1;
        label.textContent = label.dataset.balanceFallback;
        const sdk = window.joyInstance;
        if (typeof sdk?.customer !== 'function') return;
        let timeout;
        try {
          const member = await Promise.race([
            sdk.customer(),
            new Promise((resolve, reject) => { timeout = setTimeout(() => reject(new Error('timeout')), 8000); })
          ]);
          if (!this.isConnected || requestId !== this.bamsRequest) return;
          if (String(member?.shopifyCustomerId || '').split('/').pop() !== label.dataset.customerId) return;
          const raw = member.point;
          if (typeof raw !== 'number' && (typeof raw !== 'string' || raw.trim() === '')) return;
          const points = Number(raw);
          if (!Number.isFinite(points)) return;
          const formatted = new Intl.NumberFormat(document.documentElement.lang || navigator.language, {maximumFractionDigits: 20}).format(points);
          label.textContent = label.dataset.balanceTemplate.replace('__BBM_POINTS__', formatted);
        } catch (error) {
          if (!this.isConnected) return;
        } finally {
          clearTimeout(timeout);
        }
      }
      selectTab(name) {
        if (!this.tabs.some(tab => tab.dataset.bbmTab === name)) name = this.tabs[0]?.dataset.bbmTab;
        this.tabs.forEach(tab => {
          const selected = tab.dataset.bbmTab === name;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.bbmPanel !== name; });
      }
      refreshCollections() {
        this.querySelectorAll('[data-bbm-feature]').forEach(card => this.refreshCollection(card));
      }
      async refreshCollection(card) {
        if (card.bbmLoading) return;
        card.bbmLoading = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const url = new URL(card.href, window.location.href);
          if (url.origin !== window.location.origin) return;
          url.search = '';
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('section_id', 'bambola-menu-collection');
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = html.querySelector('[data-bbm-result]');
          if (!result || result.dataset.collectionId !== card.dataset.collectionId) return;
          card.hidden = result.dataset.empty === 'true';
          if (card.hidden) return;
          const source = result.querySelector('img');
          const media = card.querySelector('[data-bbm-media]');
          if (source) {
            source.alt = '';
            source.loading = 'eager';
            source.decoding = 'async';
            media.replaceChildren(document.importNode(source, true));
          } else {
            media.replaceChildren();
          }
          card.dataset.productId = result.dataset.productId || '';
        } catch (error) {
          if (!this.isConnected) return;
        } finally {
          clearTimeout(timeout);
          card.bbmLoading = false;
        }
      }
    }
    customElements.define('bambola-mobile-menu', BambolaMobileMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-desktop-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bambola-desktop-menu')) {
    customElements.define('bambola-desktop-menu', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.header = this.closest('#SiteHeader');
        this.disclosures = Array.from(this.querySelectorAll('[data-bbd-disclosure]'));
        this.desktop = window.matchMedia('(min-width:769px)');
        this.hoverPointer = window.matchMedia('(hover:hover) and (pointer:fine)');
        this.disclosures.forEach(disclosure => {
          const trigger = disclosure.querySelector('[data-bbd-trigger]');
          trigger.setAttribute('aria-expanded', String(disclosure.open));
          trigger.addEventListener('click', event => {
            event.preventDefault();
            this.toggleMenu(disclosure, !disclosure.open);
          }, options);
          disclosure.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !this.desktop.matches || !this.hoverPointer.matches) return;
            clearTimeout(this.closeTimer);
            this.toggleMenu(disclosure, true);
          }, options);
          disclosure.addEventListener('pointerleave', event => {
            if (event.pointerType !== 'mouse' || !disclosure.open) return;
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(() => {
              const panel = disclosure.querySelector('.bbd-panel');
              if (disclosure.open && !disclosure.matches(':hover') && !panel.contains(document.activeElement)) this.closeAll();
            }, 240);
          }, options);
          disclosure.querySelector('[data-bbd-close]').addEventListener('click', () => this.closeAll(true), options);
        });
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
        document.addEventListener('focusin', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.disclosures.some(item => item.open)) {
            event.preventDefault();
            this.closeAll(true);
          }
        }, options);
        this.querySelector('[data-bbd-backdrop]').addEventListener('click', () => this.closeAll(), options);
        ['drawerOpen','modalOpen','predictive-search:open'].forEach(name => document.addEventListener(name, () => this.closeAll(), options));
        this.desktop.addEventListener('change', () => this.closeAll(), options);
        this.onPosition = () => {
          if (this.positionFrame) return;
          this.positionFrame = requestAnimationFrame(() => { this.positionFrame = 0; this.updatePosition(); });
        };
        window.addEventListener('scroll', this.onPosition, {...options,passive:true});
        window.addEventListener('resize', this.onPosition, options);
        if (this.header) {
          this.observer = new ResizeObserver(this.onPosition);
          this.observer.observe(this.header);
        }
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.requests?.abort();
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.positionFrame);
      }
      closeAll(returnFocus = false) {
        clearTimeout(this.closeTimer);
        const opened = this.disclosures.find(item => item.open);
        this.disclosures.forEach(item => {
          item.open = false;
          item.querySelector('[data-bbd-trigger]').setAttribute('aria-expanded','false');
        });
        if (returnFocus) opened?.querySelector('[data-bbd-trigger]').focus();
      }
      toggleMenu(disclosure, open) {
        if (!this.desktop.matches) return;
        if (disclosure.open === open) return;
        this.closeAll();
        disclosure.open = open;
        disclosure.querySelector('[data-bbd-trigger]').setAttribute('aria-expanded',String(open));
        if (open) {
          this.updatePosition();
          if (disclosure.querySelector('[data-bbd-feature]')) this.refreshCollections(disclosure);
        }
      }
      updatePosition() {
        if (!this.header || !this.disclosures.some(item => item.open)) return;
        const bottom = Math.max(0, Math.ceil(this.header.getBoundingClientRect().bottom));
        this.style.setProperty('--bbd-header-bottom', bottom + 'px');
      }
      async refreshCollections(disclosure) {
        this.requests?.abort();
        const controller = this.requests = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          await Promise.all(Array.from(disclosure.querySelectorAll('[data-bbd-feature]')).map(async card => {
            try {
              const url = new URL(card.href);
              if (url.origin !== location.origin) return;
              url.searchParams.set('sort_by','created-descending');
              url.searchParams.set('section_id','bambola-desktop-collection');
              const preview = new URL(location.href).searchParams.get('preview_theme_id');
              if (preview) url.searchParams.set('preview_theme_id',preview);
              const response = await fetch(url, {credentials:'same-origin',cache:'no-cache',signal:controller.signal});
              if (!response.ok) return;
              const html = new DOMParser().parseFromString(await response.text(),'text/html');
              const result = html.querySelector('[data-bbd-result]');
              if (!result || result.dataset.collectionId !== card.dataset.collectionId || controller.signal.aborted || !this.isConnected) return;
              const media = card.querySelector('[data-bbd-media]');
              const image = result.querySelector('img');
              if (image) {
                const copy = document.importNode(image,true);
                copy.loading = 'eager';
                media.replaceChildren(copy);
              } else media.replaceChildren();
              card.dataset.productId = result.dataset.productId || '';
            } catch (error) { if (controller.signal.aborted) return; }
          }));
        } finally { clearTimeout(timeout); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const sectionSelector = '.collection-content[data-section-type="collection-grid"], .template-index [data-section-type="collection-grid"][data-context="featured-collection"], .template-product product-recommendations, .template-product [data-section-type="recently-viewed"]';
    const cardSelector = '.grid-product';
    const tracked = new Map();
    const watchedSections = new WeakSet();
    let frame = 0;
    let retryTimer = 0;
    let retries = 0;

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(refresh);
    }

    const sizes = new ResizeObserver(schedule);

    function styleButton(host) {
      const root = host.shadowRoot;
      if (!root) return false;
      if (!root.querySelector('#bambola-collection-wishlist-style')) {
        const style = document.createElement('style');
        style.id = 'bambola-collection-wishlist-style';
        style.textContent = `
            :host([data-bambola-card-tools]) .Joy-Wishlist__Button {
              background: transparent !important;
              background-color: transparent !important;
              border: 0 !important;
              border-radius: 0 !important;
              box-shadow: none !important;
              padding: 0 !important;
              width: 40px !important;
              min-width: 40px !important;
              height: 40px !important;
              min-height: 40px !important;
            }
        `;
        root.appendChild(style);
      }
      return true;
    }

    function refresh() {
      frame = 0;
      let pending = false;

      tracked.forEach((state, card) => {
        if (!card.isConnected) {
          sizes.unobserve(card);
          state.observer?.disconnect();
          tracked.delete(card);
        }
      });

      document.querySelectorAll(sectionSelector).forEach(section => {
        if (!watchedSections.has(section)) {
          new MutationObserver(() => {
            retries = 0;
            schedule();
          }).observe(section, { childList: true, subtree: true });
          watchedSections.add(section);
        }

        section.querySelectorAll(cardSelector).forEach(card => {
          if (card.parentElement.closest('.grid-product')) return;
          const row = card.querySelector('.bambola-grid-title-colors');
          if (!row) return;

          if (!tracked.has(card)) {
            tracked.set(card, { host: null, observer: null });
            sizes.observe(card);
          }

          const host = card.querySelector(':scope > joy-wishlist-button[type="collection"]');
          if (!host) return;
          const state = tracked.get(card);

          if (state.host !== host) {
            state.observer?.disconnect();
            state.host = host;
            state.observer = null;
          }

          if (!styleButton(host)) {
            pending = true;
            return;
          }

          if (!state.observer) {
            state.observer = new MutationObserver(schedule);
            state.observer.observe(host.shadowRoot, { childList: true, subtree: true });
          }

          const cardBox = card.getBoundingClientRect();
          const rowBox = row.getBoundingClientRect();
          host.style.setProperty('--bambola-wishlist-top', `${rowBox.top - cardBox.top - card.clientTop + card.scrollTop}px`);
          host.style.setProperty('--bambola-wishlist-right', `${cardBox.right - rowBox.right - card.clientLeft}px`);
          host.setAttribute('data-bambola-card-tools', '');
        });
      });

      if (pending && retries < 20 && !retryTimer) {
        retries += 1;
        retryTimer = window.setTimeout(() => {
          retryTimer = 0;
          schedule();
        }, 250);
      }
    }

    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    document.fonts?.ready.then(schedule);
    customElements.whenDefined('joy-wishlist-button').then(schedule);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-sharing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bambola-product-share')) {
    customElements.define('bambola-product-share', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-share-action]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-share-action]');
          if (!button || !this.contains(button)) return;
          const action = button.dataset.shareAction;
          if (action === 'copy') this.copyLink();
          if (action === 'native') this.shareLink();
          if (action === 'close') this.closePanel();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.querySelector('.bambola-share__panel').hidden) {
            event.preventDefault();
            this.closePanel();
          }
        });
      }
      disconnectedCallback() {
        clearTimeout(this.statusTimer);
      }
      showPanel(manual = false) {
        this.querySelector('.bambola-share__panel').hidden = false;
        this.querySelector('.bambola-share__manual').hidden = !manual;
        if (manual) {
          const input = this.querySelector('input');
          input.focus();
          input.select();
        } else {
          this.querySelector('.bambola-share__more a').focus();
        }
      }
      closePanel() {
        this.querySelector('.bambola-share__panel').hidden = true;
        this.querySelector('[data-share-action="native"]').focus();
      }
      async copyLink() {
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(this.dataset.shareUrl);
          const status = this.querySelector('.bambola-share__status');
          status.textContent = this.dataset.copied;
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => { status.textContent = ''; }, 3500);
        } catch (error) {
          this.showPanel(true);
        }
      }
      async shareLink() {
        const data = { title: this.dataset.shareTitle, url: this.dataset.shareUrl };
        if (typeof navigator.share !== 'function') {
          this.showPanel();
          return;
        }
        try {
          await navigator.share(data);
        } catch (error) {
          if (error.name !== 'AbortError') this.showPanel();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tab"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('bambola-product-care')) return;

    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim();
    const negative = /^(?:no\b|non\b|nao\b|do not\b|don't\b|ne pas\b|nicht\b|niet\b|kein\b|ne jamais\b|sense\b)/;
    const wash = /\b(?:lavar|rentar|rentat|wash|washing|laver|lavage|lavare|lavaggio|waschen|waschgang|maschinenwasche|handwasche|wassen|handwas|machinewas)\b/;
    const bleach = /\b(?:lej[ií]a|blanqueador|lleixiu|bleach|bleaching|javel|blanchiment|blanchir|lixivia|alvejante|candeggina|candeggiare|sbiancare|bleichen|bleekmiddel|bleken)\b/;
    const iron = /\b(?:planchar|planchado|planxa|planxar|planxat|iron|ironing|repasser|repassage|passar|engomar|stirare|stiratura|bugeln|strijken)\b/;
    const tumble = /\b(?:secadora|assecadora|tumble|dryer|seche-linge|seche linge|secador|maquina de secar|asciugatrice|trockner|trommeltrocknen|wasdroger|droogtrommel)\b/;
    const flat = /\b(?:secar|assecar|dry|secher|sechage|asciugare|asciugatura|trocknen|drogen)\b.*\b(?:horizontal|flat|plano|plat|piano|liegend|liggend)\b/;
    const label = /\b(?:etiqueta|label|etichetta|etikett|pflegeetikett|etiquette|wasetiket|fabrikant)\b/;
    const hand = /\b(?:mano|ma|hand|main|mao|handwasche|handwas)\b/;
    const noWash = /^(?:no lavar|no rentar|do not wash|don't wash|ne pas laver|nao lavar|non lavare|nicht waschen|niet wassen)[.!]?$/;

    function classify(value) {
      const text = normalize(value);
      if (label.test(text)) return { kind: 'label' };
      const kinds = [wash.test(text), bleach.test(text), iron.test(text), tumble.test(text), flat.test(text)];
      if (kinds.filter(Boolean).length !== 1) return null;
      const forbidden = negative.test(text);
      if (kinds[1]) {
        if (!forbidden) return null;
        return { kind: 'bleach', forbidden: true };
      }
      if (kinds[2]) {
        const temperature = text.match(/\b(110|150|200)\s*(?:[°º]|degrees|degres|grados|graus|gradi|grad|graden)/);
        const dots = temperature ? {110: 1, 150: 2, 200: 3}[temperature[1]] : 0;
        return { kind: 'iron', forbidden, dots: forbidden ? 0 : dots };
      }
      if (kinds[3]) {
        if (!forbidden) return null;
        return { kind: 'tumble', forbidden: true };
      }
      if (kinds[4]) return forbidden ? null : { kind: 'flat' };
      if (forbidden) return noWash.test(text) ? { kind: 'wash', forbidden: true } : null;
      if (hand.test(text)) return { kind: 'hand' };
      const temperature = text.match(/\b(20|30|40|50|60|70|90|95)\s*(?:[°º]|degrees|degres|grados|graus|gradi|grad|graden)/);
      return temperature ? { kind: 'wash', temperature: temperature[1] } : null;
    }

    function makeIcon(info) {
      if (!info) return null;
      const paths = {
        wash: '<path d="M3 8l3.5 19h23L33 8M4 12c2.4-3 4.8 3 7.2 0s4.8 3 7.2 0 4.8 3 7.2 0 4.8 3 6.7 0"/>',
        bleach: '<path d="M18 4L3 30h30Z"/>',
        iron: '<path d="M4 28h28l-4-19H13M29 16H15C9 16 6 22 4 28Z"/>',
        tumble: '<rect x="4" y="4" width="28" height="28"/><circle cx="18" cy="18" r="12"/>',
        flat: '<rect x="4" y="4" width="28" height="28"/><path d="M8 18h20"/>',
        label: '<path d="M4 20L20 4h11v11L15 31Z"/><circle cx="26" cy="9" r="1.7"/>',
        hand: '<path d="M3 17l3 14h24l3-14M4 20c2-2 4 2 6 0s4 2 6 0 4 2 6 0 4 2 6 0 4 2 4 0M13 20l-2-6c-.6-2 1-3 2-1l2 4V6c0-2 3-2 3 0v8-9c0-2 3-2 3 0v9-7c0-2 3-2 3 0v8-4c0-2 3-2 3 0v10c0 4-3 6-7 6-3 0-5-2-7-7Z"/>'
      };
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      for (const [key, value] of Object.entries({viewBox:'0 0 36 36',fill:'none',stroke:'currentColor','stroke-width':'1.45','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) svg.setAttribute(key, value);
      svg.innerHTML = paths[info.kind];
      if (info.temperature) {
        const number = document.createElementNS(svg.namespaceURI, 'text');
        for (const [key, value] of Object.entries({x:'18',y:'23','text-anchor':'middle',fill:'currentColor',stroke:'none','font-family':'inherit','font-size':'11','font-weight':'400'})) number.setAttribute(key, value);
        number.textContent = info.temperature;
        svg.append(number);
      }
      for (let i = 0; i < (info.dots || 0); i++) {
        const dot = document.createElementNS(svg.namespaceURI, 'circle');
        dot.setAttribute('cx', String(19 - (info.dots - 1) * 2.5 + i * 5));
        dot.setAttribute('cy', '23');
        dot.setAttribute('r', '1');
        dot.setAttribute('fill', 'currentColor');
        svg.append(dot);
      }
      if (info.forbidden) {
        const cross = document.createElementNS(svg.namespaceURI, 'path');
        cross.setAttribute('d', 'M3 3l30 30M33 3L3 33');
        svg.append(cross);
      }
      return svg;
    }

    customElements.define('bambola-product-care', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.enhance(), {once:true});
        else this.enhance();
      }

      enhance() {
        if (this.classList.contains('is-ready')) return;
        if (this.querySelector('li ul, li ol')) return;
        const entries = [...this.querySelectorAll('li, p')].filter(node => !(node.matches('p') && node.closest('li')));
        for (const entry of entries) {
          if (!entry.textContent.trim() || entry.querySelector('br')) continue;
          const info = classify(entry.textContent);
          const text = document.createElement(entry.tagName === 'LI' ? 'div' : 'span');
          text.className = 'bambola-care-text';
          text.append(...entry.childNodes);
          const icon = document.createElement('span');
          icon.className = 'bambola-care-icon';
          icon.setAttribute('aria-hidden', 'true');
          const svg = makeIcon(info);
          if (svg) icon.append(svg);
          entry.classList.add('bambola-care-row');
          if (info?.kind === 'label') entry.classList.add('bambola-care-note');
          if (info) entry.dataset.careIcon = info.kind;
          entry.append(icon, text);
        }
        this.classList.add('is-ready');
      }
    });
  })();
  (() => {
    if (customElements.get('bambola-product-shipping')) return;
    const norm = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').toLowerCase().replace(/\s+/g, ' ').trim();
    const returns = /^(?:devolucio|return|retour|ruckgabe|rucksendung|resi\b|reso\b|devolu)/;
    const money = /(?:€\s*\d+(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?\s*(?:€|EUR\b))/iu;
    const pickup = /\b(?:punto|punt|pickup|pick-up|point|ponto|afhaalpunt|abholstelle|abholpunkt|ritiro)\b/;
    const home = /domicil|\bhome delivery\b|hauslieferung|nach hause|thuisbezorg|thuislever|consegna a casa/;
    const free = /gratu[iï]t|\bgratis\b|\bfree (?:delivery|shipping)\b|kostenlos|versandkostenfrei/;
    const period = /\b\d+\s*(?:d[ií]as|dies|days|jours|dias|giorni|Tage|dagen)\b/iu;
    const time = /\b\d+\s*(?:[–—-]|a|à|to|bis|até|ate)\s*\d+\s*(?:d[ií]as|dies|days|jours|dias|giorni|Werktage|werkdagen)\b/iu;
    const iconPaths = {
      home: '<path d="M2 5h13v12H2zM15 9h4l3 4v4h-7M5 17a2 2 0 1 0 4 0M16 17a2 2 0 1 0 4 0"/>',
      pickup: '<path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/>',
      return: '<path d="M9 4L4 9l5 5M4 9h11a6 6 0 0 1 0 12h-3"/>',
      clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
      package: '<path d="M3 7l9-5 9 5v10l-9 5-9-5ZM3 7l9 5 9-5M12 12v10M7.5 4.5l9 5"/>',
      label: '<path d="M3 13L13 3h8v8L11 21Z"/><circle cx="17" cy="7" r="1"/>',
      mail: '<rect x="3" y="5" width="18" height="14" rx="1"/><path d="M3 6l9 7 9-7"/>',
      payment: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20M6 15h3"/>'
    };

    function icon(kind) {
      const box = document.createElement('span');
      box.className = 'bambola-ship-icon';
      box.setAttribute('aria-hidden', 'true');
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      for (const [key,value] of Object.entries({viewBox:'0 0 24 24',width:'24',height:'24',fill:'none',stroke:'currentColor','stroke-width':'1.45','stroke-linecap':'round','stroke-linejoin':'round',focusable:'false'})) svg.setAttribute(key,value);
      svg.innerHTML = iconPaths[kind];
      box.append(svg);
      return box;
    }

    function inlineSlice(source, start, end) {
      let offset = 0;
      function visit(node) {
        if (node.nodeType === 3) {
          const a = offset;
          offset += node.textContent.length;
          const value = node.textContent.slice(Math.max(0,start-a),Math.max(0,Math.min(offset,end)-a));
          return value ? document.createTextNode(value) : null;
        }
        if (node.nodeType !== 1) return null;
        const clone = node.cloneNode(false);
        for (const child of node.childNodes) { const part = visit(child); if (part) clone.append(part); }
        return clone.childNodes.length ? clone : null;
      }
      const out = document.createDocumentFragment();
      for (const child of source.childNodes) { const part = visit(child); if (part) out.append(part); }
      return out;
    }

    function trimRange(text, start, end) {
      const part = text.slice(start,end);
      const before = part.match(/^[\s:—–.\-]+/)?.[0].length || 0;
      const after = part.match(/[\s:—–.\-]+$/)?.[0].length || 0;
      return [start+before,Math.max(start+before,end-after)];
    }

    function row(source, kind, price) {
      const text = source.textContent;
      const out = document.createElement('div');
      out.className = 'bambola-ship-row';
      out.dataset.shippingKind = kind;
      out.dataset.sourceText = text;
      out.append(icon(kind));
      const copy = document.createElement('div');
      const label = document.createElement('span');
      label.className = 'bambola-ship-label';
      label.append(inlineSlice(source,...trimRange(text,0,price.index)));
      copy.append(label);
      const [a,b] = trimRange(text,price.index+price[0].length,text.length);
      if (a < b) {
        const detail = document.createElement('span');
        detail.className = 'bambola-ship-detail';
        detail.append(inlineSlice(source,a,b));
        copy.append(detail);
      }
      const amount = document.createElement('span');
      amount.className = 'bambola-ship-price';
      amount.textContent = price[0].replace(/EUR/i,'€').trim();
      out.append(copy,amount);
      return out;
    }

    function freeBanner(source, scopes) {
      const out = document.createElement('div');
      out.className = 'bambola-ship-free';
      out.append(icon('package'));
      const copy = document.createElement('div');
      copy.append(source.cloneNode(true));
      if (scopes?.length > 1) {
        const names = document.createElement('div');
        names.className = 'bambola-ship-free-scopes';
        names.textContent = scopes.join(' · ');
        copy.append(names);
      }
      out.append(copy);
      return out;
    }

    function note(source, kind) {
      const clone = source.cloneNode(true);
      clone.classList.add('bambola-ship-note');
      if (!kind) return clone;
      const out = document.createElement('div');
      out.className = 'bambola-ship-note-row';
      out.append(icon(kind),clone);
      return out;
    }

    function returnIcon(text) {
      if (/organis|organiz|regel en betaal|contrat|transport|carrier|corrier|versanddienstleister/.test(text)) return 'package';
      if (/reembols|reembors|refund|rembours|rimborso|erstatt|terugbetaal/.test(text)) return 'payment';
      if (/email|e-mail|courriel|correu|correo/.test(text)) return 'mail';
      if (/articul|article|artigo|articoli|artikel/.test(text)) return 'label';
      return null;
    }

    function sectionsFrom(root) {
      let nodes = [...root.childNodes];
      if (nodes.filter(n=>n.nodeType === 1).length === 1) {
        const first = nodes.find(n=>n.nodeType === 1);
        if (first.tagName === 'DIV') nodes = [...first.childNodes];
      }
      const sections = [];
      let current = {heading:null,items:[],isReturn:false};
      sections.push(current);
      for (const node of nodes) {
        if (node.nodeType === 3 && !node.textContent.trim()) continue;
        if (node.nodeType !== 1 || !['P','H2','H3','H4'].includes(node.tagName)) return null;
        const text = node.textContent.trim();
        if (!text) continue;
        const bold = node.querySelector('strong,b');
        const heading = /^H[234]$/.test(node.tagName) || (bold && bold.textContent.trim() === text && text.length < 160 && !/[.!?]$/.test(text));
        if (heading) {
          current = {heading:node,items:[],isReturn:returns.test(norm(text))};
          sections.push(current);
        } else current.items.push(node);
      }
      return sections.filter(s=>s.heading || s.items.length);
    }

    function enhance(root) {
      if (root.classList.contains('is-ready')) return;
      const sections = sectionsFrom(root);
      if (!sections || !sections.some(s=>s.isReturn)) return;
      const shippingSections = sections.filter(s=>!s.isReturn && s.items.length);
      const sharedFree = shippingSections.map(s=>s.items.filter(n=>free.test(norm(n.textContent)) && money.test(n.textContent)));
      const combineFree = shippingSections.length > 1 && sharedFree.every(v=>v.length === 1 && norm(v[0].textContent) === norm(sharedFree[0][0]?.textContent || ''));
      const fragment = document.createDocumentFragment();
      let freeAdded = false;
      for (const section of sections) {
        if (section.isReturn && combineFree && !freeAdded) {
          fragment.append(freeBanner(sharedFree[0][0],shippingSections.map(s=>s.heading?.textContent.trim()).filter(Boolean)));
          freeAdded = true;
        }
        const out = document.createElement('section');
        out.className = 'bambola-ship-section';
        if (section.isReturn) out.classList.add('bambola-ship-returns');
        if (section.heading) {
          const heading = document.createElement('div');
          heading.className = 'bambola-ship-heading';
          const title = document.createElement('h3');
          title.append(...section.heading.cloneNode(true).childNodes);
          heading.append(title);
          if (section.isReturn) {
            const match = section.items.map(n=>n.textContent.match(period)).find(Boolean);
            if (match) {
              const badge = document.createElement('span');
              badge.className = 'bambola-ship-period';
              badge.textContent = match[0];
              heading.append(badge);
            }
          }
          out.append(heading);
        }
        let lastRow = null;
        const timeItems = section.items.filter(n=>time.test(n.textContent) && !money.test(n.textContent));
        for (const item of section.items) {
          const text = item.textContent;
          const normalized = norm(text);
          const price = text.match(money);
          if (!section.isReturn && free.test(normalized) && price) {
            if (!combineFree) out.append(freeBanner(item));
            continue;
          }
          let kind = null;
          if (price && price.index > 0 && !text.slice(price.index+price[0].length).match(money)) {
            if (!section.isReturn && pickup.test(normalized)) kind = 'pickup';
            else if (!section.isReturn && home.test(normalized)) kind = 'home';
            else if (section.isReturn && normalized.length < 115) kind = 'return';
          }
          if (kind) {
            lastRow = row(item,kind,price);
            out.append(lastRow);
          } else if (!section.isReturn && time.test(text) && !price) {
            if (lastRow && timeItems.length > 1 && text.length < 90) {
              const detail = item.cloneNode(true);
              detail.classList.add('bambola-ship-detail');
              lastRow.children[1].append(detail);
            } else out.append(note(item,'clock'));
            lastRow = null;
          } else {
            out.append(note(item,section.isReturn ? returnIcon(normalized) : null));
            lastRow = null;
          }
        }
        fragment.append(out);
      }
      if (combineFree && !freeAdded) fragment.append(freeBanner(sharedFree[0][0],shippingSections.map(s=>s.heading?.textContent.trim()).filter(Boolean)));
      root.replaceChildren(fragment);
      root.classList.add('is-ready');
    }

    customElements.define('bambola-product-shipping', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>enhance(this),{once:true});
        else enhance(this);
      }
    });
  })();
  (() => {
    if (customElements.get('bambola-product-details')) return;
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss').toLowerCase().trim();
    const vertical = /\b(?:largo|llarg|llargada|longueur|length|comprimento|lunghezza|lange|lengte|tiro|rise|entrejambe|gancho|cavallo|leibh[oö]he|kruishoogte|alto|altura|alcada|height|hauteur|altezza|hohe|hoogte)\b/;
    const horizontal = /\b(?:pecho|pit|chest|bust|buste|poitrine|peito|petto|brust|borst|cadera|maluc|hip|hanche|anca|quadril|fianchi|hufte|heup|cintura|waist|taille|vita|ancho|ample|amplada|width|largeur|largura|larghezza|breite|breedte)\b/;

    function measureIcon(label) {
      const value = normalize(label);
      const kind = vertical.test(value) ? 'vertical' : horizontal.test(value) ? 'horizontal' : 'ruler';
      const paths = {
        horizontal: 'M3 12h18M7 8l-4 4 4 4M17 8l4 4-4 4',
        vertical: 'M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4',
        ruler: 'M3 7h18v10H3ZM7 7v4M12 7v6M17 7v4'
      };
      const box = document.createElement('span');
      box.className = 'bambola-measure-icon';
      box.setAttribute('aria-hidden','true');
      const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      for (const [key,value] of Object.entries({viewBox:'0 0 24 24',width:'22',height:'22',fill:'none',stroke:'currentColor','stroke-width':'1.35','stroke-linecap':'round','stroke-linejoin':'round',focusable:'false'})) svg.setAttribute(key,value);
      const path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('d',paths[kind]);
      svg.append(path);
      box.append(svg);
      return box;
    }

    function parseMeasurements(text) {
      let group = '';
      const prefix = text.match(/^([^:\n]{1,50}):\s*(?=[\p{L}][^:/\n]{0,69}:\s*\d)/u);
      if (prefix) { group = prefix[1].trim(); text = text.slice(prefix[0].length); }
      const parts = text.split(/\s*\/\s*(?=[\p{L}][^:/\n]{0,69}:)/u);
      const values = [];
      for (const part of parts) {
        const match = part.trim().match(/^([\p{L}][^:\n]{0,69}):\s*(\d[^:\n]{0,99})$/u);
        if (!match) return null;
        values.push({label:match[1].trim(),value:match[2].trim()});
      }
      return values.length ? {group,values} : null;
    }

    function measurementNodes(parsed) {
      const out = document.createDocumentFragment();
      if (parsed.group) {
        const heading = document.createElement('h3');
        heading.className = 'bambola-measure-group';
        heading.textContent = parsed.group;
        out.append(heading);
      }
      const list = document.createElement('dl');
      list.className = 'bambola-measure-grid';
      const count = parsed.values.length;
      const columns = count === 4 ? 2 : Math.min(count,3);
      list.style.setProperty('--bambola-measure-columns',columns);
      for (const item of parsed.values) {
        const cell = document.createElement('div');
        cell.className = 'bambola-measure-cell';
        const label = document.createElement('dt');
        label.className = 'bambola-measure-label';
        label.append(measureIcon(item.label),document.createTextNode(item.label));
        const value = document.createElement('dd');
        value.className = 'bambola-measure-value';
        value.textContent = item.value;
        cell.append(label,value);
        list.append(cell);
      }
      out.append(list);
      return out;
    }

    function parseComposition(text) {
      const parts = text.split(/\s*\/\s*/u).flatMap(part => /^\s*\d+(?:[.,]\d+)?\s*%/u.test(part) ? part.split(/\s+(?=\d+(?:[.,]\d+)?\s*%)/u) : [part]).map(s=>s.trim()).filter(Boolean);
      const values = [];
      for (const part of parts) {
        const matches = [...part.matchAll(/\d+(?:[.,]\d+)?\s*%/gu)];
        if (matches.length > 1) return null;
        if (!matches.length) {
          if (/[%:\d]/.test(part) || part.length > 80) return null;
          values.push({material:part,percent:''});
        } else {
          const match = matches[0];
          const isStart = match.index === 0;
          const isEnd = match.index+match[0].length === part.length;
          if ((!isStart && !isEnd) || parseFloat(match[0].replace(',','.')) > 100) return null;
          const material = part.replace(match[0],'').trim();
          if (!material || /[%:\d]/.test(material)) return null;
          values.push({material,percent:match[0]});
        }
      }
      return values.length ? values : null;
    }

    function compositionNodes(items) {
      const list = document.createElement('ul');
      list.className = 'bambola-composition-list';
      for (const item of items) {
        const row = document.createElement('li');
        row.className = 'bambola-composition-row';
        const material = document.createElement('span');
        material.className = 'bambola-composition-material';
        material.textContent = item.material;
        row.append(material);
        if (item.percent) {
          const percent = document.createElement('span');
          percent.className = 'bambola-composition-percent';
          percent.textContent = item.percent;
          row.append(document.createTextNode(' '),percent);
        }
        list.append(row);
      }
      return list;
    }

    function compactMeasurements(output, root) {
      const key = label => normalize(label).replace(/\s+/g,' ');
      const nodes = [...output.childNodes].filter(node=>node.nodeType===1 || node.textContent.trim());
      const runs = [];
      let run = [];
      for (let index=0; index<nodes.length; index++) {
        const heading = nodes[index];
        const grid = nodes[index+1];
        const text = heading.textContent.trim();
        const isHeading = heading.nodeType===1 && (heading.classList.contains('bambola-measure-group') || (heading.classList.contains('bambola-detail-note') && text.length<=32 && !/[:.!?]/.test(text) && !heading.querySelector('a')));
        if (isHeading && grid?.nodeType===1 && grid.classList.contains('bambola-measure-grid')) {
          const values = [...grid.children].map(cell=>({label:cell.querySelector('dt').textContent.trim(),value:cell.querySelector('dd').textContent.trim()}));
          run.push({heading,grid,name:text,values});
          index++;
        } else { if (run.length) runs.push(run); run=[]; }
      }
      if (run.length) runs.push(run);
      for (const groups of runs) {
        if (groups.length<3 || new Set(groups.map(group=>key(group.name))).size!==groups.length) continue;
        if (groups.some(group=>new Set(group.values.map(item=>key(item.label))).size!==group.values.length)) continue;
        const columns = [];
        for (const group of groups) for (const item of group.values) if (!columns.some(column=>key(column)===key(item.label))) columns.push(item.label);
        const wrap = document.createElement('div');
        wrap.className = 'bambola-size-table-wrap';
        const table = document.createElement('table');
        table.className = 'bambola-size-table';
        const title = root.closest('.collapsible-content')?.previousElementSibling?.textContent.trim();
        if (title) table.setAttribute('aria-label',title);
        if (columns.length>4) table.dataset.wide = '';
        const thead = document.createElement('thead');
        const header = document.createElement('tr');
        header.append(document.createElement('td'));
        for (const label of columns) {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.textContent = label;
          header.append(cell);
        }
        thead.append(header);
        const tbody = document.createElement('tbody');
        for (const group of groups) {
          const row = document.createElement('tr');
          const heading = document.createElement('th');
          heading.scope = 'row';
          heading.append(...group.heading.cloneNode(true).childNodes);
          row.append(heading);
          for (const label of columns) {
            const cell = document.createElement('td');
            const item = group.values.find(value=>key(value.label)===key(label));
            cell.textContent = item?.value || '—';
            row.append(cell);
          }
          tbody.append(row);
        }
        table.append(thead,tbody);
        wrap.append(table);
        groups[0].heading.before(wrap);
        for (const group of groups) { group.heading.remove(); group.grid.remove(); }
      }
    }

    function enhance(root) {
      if (root.classList.contains('is-ready')) return;
      const source = root.cloneNode(true);
      let container = source;
      while (container.children.length === 1 && container.firstElementChild.tagName === 'DIV' && [...container.childNodes].every(n=>n.nodeType===1 || !n.textContent.trim())) container = container.firstElementChild;
      const output = document.createDocumentFragment();
      let changed = false;
      for (const node of [...container.childNodes]) {
        if (!node.textContent.trim()) { output.append(node.cloneNode(true)); continue; }
        const simple = node.nodeType === 3 || (node.nodeType === 1 && ['P','SPAN'].includes(node.tagName) && ![...node.querySelectorAll('*')].some(el=>!['STRONG','B','EM','I','SPAN','BR'].includes(el.tagName)));
        if (!simple) { output.append(node.cloneNode(true)); continue; }
        const textNode = node.cloneNode(true);
        if (textNode.nodeType === 1) textNode.querySelectorAll('br').forEach(br=>br.replaceWith('\n'));
        const lines = textNode.textContent.split(/\n/).map(s=>s.trim()).filter(Boolean);
        const isMeasure = root.dataset.kind === 'measurements';
        const parsed = lines.map(isMeasure ? parseMeasurements : parseComposition);
        if (!parsed.length || parsed.some(p=>!p)) {
          const copy = node.cloneNode(true);
          if (copy.nodeType === 1) copy.classList.add('bambola-detail-note');
          output.append(copy);
          continue;
        }
        for (const data of parsed) output.append(isMeasure ? measurementNodes(data) : compositionNodes(data));
        changed = true;
      }
      if (changed) {
        if (root.dataset.kind === 'measurements') compactMeasurements(output, root);
        root.replaceChildren(output);
        root.classList.add('is-ready');
      }
    }

    customElements.define('bambola-product-details', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>enhance(this),{once:true});
        else enhance(this);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
